import {
   ConfidentialResourceAccessRequestCountEvent,
   ConfidentialResourceAccessRequestQuery,
   RequestStatus,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { useCqrsCount, useCqrsEvent, UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

const PENDING_STATUS: RequestStatus = 'PENDING';

export const useConfidentialResourceAccessRequestsPendingCount = (): UseCqrsQueryResult<number> => {
   const result = useCqrsCount(() => {
      const query = new ConfidentialResourceAccessRequestQuery();
      query.requestStatus = Slot.of(PENDING_STATUS);

      return query;
   });

   useCqrsEvent<ConfidentialResourceAccessRequestCountEvent>(
      'egabinet-medical-data-confidentiality-frontend-api:ConfidentialResourceAccessRequestCountEvent',
      (event) => result.setData(event.count)
   );

   return result;
};
